import { toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2128ceb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { for: "titulo" }
const _hoisted_2 = {
  key: 0,
  class: "erro"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.esteRotulo) + " ", 1),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      id: "tituloFormulario",
      name: "tituloFormulario",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tituloString) = $event)),
      onFocusout: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.digitou && _ctx.digitou(...args))),
      autocomplete: "off",
      required: ""
    }, null, 544), [
      [_vModelText, _ctx.tituloString]
    ]),
    (_ctx.erroString)
      ? (_openBlock(), _createElementBlock("article", _hoisted_2, _toDisplayString(_ctx.erroString), 1))
      : _createCommentVNode("", true)
  ]))
}